import React, { useEffect, useRef } from "react";
import { AUDIENCE_SORT_OPTIONS } from "../../constants/audiences";

const AudienceFiltersPopover = ({
  isOpen,
  onClose,
  containerRef,
  sortBy,
  setSortBy,
  // selectedTypes,
  // setSelectedTypes,
  // platformFilter,
  // setPlatformFilter,
  onClearAll,
  activeFilterCount = 0,
}) => {
  const popoverRef = useRef(null);
  const outsideRef = containerRef || popoverRef;

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (e) => {
      if (outsideRef.current && !outsideRef.current.contains(e.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, onClose, outsideRef]);

  if (!isOpen) return null;

  // const toggleType = (value) => {
  //   setSelectedTypes((prev) => {
  //     if (prev.includes(value)) {
  //       if (prev.length === 1) return prev;
  //       return prev.filter((type) => type !== value);
  //     }
  //     return [...prev, value];
  //   });
  // };

  return (
    <div
      ref={popoverRef}
      className="absolute right-0 top-full mt-2 z-50 w-72 bg-theme-secondary border border-theme-secondary rounded-lg shadow-lg"
    >
      <div className="p-4 space-y-4">
        <div className="flex items-center justify-between">
          <span className="text-sm font-medium text-theme-text">Filters</span>
          {activeFilterCount > 0 ? (
            <button
              type="button"
              onClick={() => {
                onClearAll();
                onClose();
              }}
              className="text-xs text-theme-primary hover:underline"
            >
              Clear all
            </button>
          ) : null}
        </div>

        <div>
          <label className="block text-xs text-theme-text opacity-60 mb-1.5">Sort</label>
          <select
            value={sortBy}
            onChange={(e) => setSortBy(e.target.value)}
            className="w-full h-8 px-2.5 rounded border border-theme-secondary bg-theme-main text-theme-text text-xs"
          >
            {AUDIENCE_SORT_OPTIONS.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        {/* <div>
          <label className="block text-xs text-theme-text opacity-60 mb-1.5">Type</label>
          <div className="flex flex-wrap gap-1.5">
            {AUDIENCE_TYPE_OPTIONS.map((option) => {
              const isActive = selectedTypes.includes(option.value);
              return (
                <button
                  key={option.value}
                  type="button"
                  onClick={() => toggleType(option.value)}
                  className={`px-2.5 py-1 text-xs rounded-md border transition-colors ${
                    isActive
                      ? "bg-theme-primary text-theme-button border-theme-primary font-medium"
                      : "bg-theme-main text-theme-text opacity-80 border-theme-secondary hover:opacity-100"
                  }`}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>

        <div>
          <label className="block text-xs text-theme-text opacity-60 mb-1.5">Platform</label>
          <select
            value={platformFilter}
            onChange={(e) => setPlatformFilter(e.target.value)}
            className="w-full h-8 px-2.5 rounded border border-theme-secondary bg-theme-main text-theme-text text-xs"
          >
            {AUDIENCE_PLATFORM_FILTER_OPTIONS.map((option) => (
              <option key={option.value || "all"} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div> */}
      </div>
    </div>
  );
};

export default AudienceFiltersPopover;
